/*
 * Created by Anup Shrestha (anup.stha012@gmail.com)
 * Copyright (c) 2022.  All rights reserved.
 * Last modified 5/9/22, 8:00 AM
 *
 */

import { Navigate, Route, Routes } from 'react-router-dom';
import { Login, NotFoundPage, Redirect } from 'App';
import { ROLE } from 'types/RoleEnum';

import { DashboardPage } from 'features/dashboard/pages/DashboardPage';
import { MemberListPage } from 'features/members';
import { InvoicePage } from 'features/members/pages/InvoicePage';
import {
  CurrentMemberProfilePage,
  SubMemberProfilePage,
} from 'features/members/pages/MemberProfilePage';
import { MemberTestReportPage } from 'features/members/pages/MemberTestReportPage';

import ProtectedRoute from 'routes/ProtectedRoute';
import { ROUTES } from 'routes/routes';

const Router = () => {
  return (
    <Routes>
      {process.env.REACT_APP_ENVIRONMENT === 'DEVELOPMENT' && (
        <Route path="/login" element={<Login />} />
      )}

      <Route path="/redirect" element={<Redirect />} />

      <Route element={<ProtectedRoute allowedRoles={[ROLE.SCHOOL_ADMIN]} />}>
        <Route path="/" element={<Navigate to={ROUTES.DASHBOARD} replace />} />
        <Route path={ROUTES.DASHBOARD} element={<DashboardPage />} />
        <Route path={ROUTES.MEMBERS} element={<MemberListPage />} />
        <Route path={ROUTES.MEMBER_PROFILE} element={<SubMemberProfilePage />} />
        <Route path={ROUTES.PROFILE} element={<CurrentMemberProfilePage />} />
        <Route path={ROUTES.MEMBER_PROFILE_COMBINED_TEST} element={<MemberTestReportPage />} />
        <Route path={ROUTES.PROFILE_INVOICE} element={<InvoicePage />} />
      </Route>

      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
};

export default Router;
